import React, { useState } from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import HappyCertificate from '../images/svg/happy-certificate.svg'
import Certified from '../images/svg/certified.svg'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Paragraph from './components/Paragraph'
import CallToAction from './components/CallToAction'

import MyModal from './components/MyModal'


const Leaders = () => {

    const [ modalKey, setModalKey ] = useState(7)
    const [ modalShow, setModalShow ] = useState(false)

    const data = useStaticQuery(graphql`
              query {
                allContentfulLeaders{
                    edges{
                    node{
                        teamsTitle
                        teamsTagline
                        teamsParagraph1
                        teamsParagraph1Keyword1
                        teamsParagraph2
                        teamsParagraph2Keyword1
                        teamsParagraph2Keyword2
                        teamsParagraph2Keyword3
                        teamsParagraph2Keyword4
                        teamsParagraph2Keyword5
                        teamsParagraph3
                        teamsParagraph3Keyword1
                        teamsParagraph3Keyword2
                        teamsParagraph3Keyword3
                        teamsParagraph3Keyword4
                        teamsCallToActionHeader
                        teamsCallToActionKeyword
                        teamsCallToActionButtonText
                        leadersButton1Title
                        leadersButton2Title
                    }
                    }
                }
            }
        `)    

        const { teamsTitle,
                teamsTagline,
                teamsParagraph1,
                teamsParagraph1Keyword1,
                teamsParagraph2,
                teamsParagraph2Keyword1,
                teamsParagraph2Keyword2,
                teamsParagraph2Keyword3,
                teamsParagraph2Keyword4,
                teamsParagraph2Keyword5,
                teamsParagraph3,
                teamsParagraph3Keyword1,
                teamsParagraph3Keyword2,
                teamsParagraph3Keyword3,
                teamsParagraph3Keyword4,
                teamsCallToActionHeader,
                teamsCallToActionKeyword,
                teamsCallToActionButtonText,
                leadersButton1Title,
                leadersButton2Title } = data.allContentfulLeaders.edges[0].node

            let paragraph1KeywordArray = [ teamsParagraph1Keyword1 ]
            let paragraph2KeywordArray = [ teamsParagraph2Keyword1, teamsParagraph2Keyword2, teamsParagraph2Keyword3, teamsParagraph2Keyword4, teamsParagraph2Keyword5, ]
            let paragraph3KeywordArray = [ teamsParagraph3Keyword1, teamsParagraph3Keyword2, teamsParagraph3Keyword3, teamsParagraph3Keyword4, ]


        const handleModalClick = ( key, modalShow ) => {
            setModalKey(key)
            setModalShow(!modalShow)
        }

        const handleModalClose = () => {
            setModalShow(false)
        }

        const onNextClick = ( key ) => {
            handleModalClose()
            setTimeout(() => {window.location=('#contact')}, 500)
        }

    return (
        <section id="leaders" className="py-5">
            <Container className="pt-5">
                    <h1
                    className="d-none d-md-block display-4 font-weight-bolder text-center text-success text-uppercase pt-3"
                    >
                    {teamsTitle}
                    </h1>
                    <h2
                    className="d-sm-block d-md-none d-lg-none d-xl-none font-weight-bolder text-center text-success text-uppercase py-5"
                    >
                    {teamsTitle}
                    </h2>

                    <h1 className="d-none d-md-block font-weight-bolder text-center text-secondary text-uppercase py-5">{teamsTagline}</h1>

                <Row>
                    <Col sm="12" md="9" className="text-center part-border-left">
                       
                       <Paragraph paragraphKeywordArray={paragraph1KeywordArray} paragraph={teamsParagraph1} type='text-success font-weight-bold' />
                       
                        <Paragraph paragraphKeywordArray={paragraph2KeywordArray} paragraph={teamsParagraph2} type='text-success font-weight-bold'  />
                       
                        <Paragraph paragraphKeywordArray={paragraph3KeywordArray} paragraph={teamsParagraph3} type='text-success font-weight-bold'  />

                    </Col>  

                    <Col md="1"></Col>

                    <Col sm="12" md="2" className="text-center">
                        <Row className="mb-2">
                            <Col>
                                <h5 className="my-2 text-center font-weight-bolder text-secondary text-uppercase">
                                {leadersButton1Title}
                                </h5>
                                
                                <Button
                                variant="light"
                                onClick={() => handleModalClick(7, modalShow)}
                                className="rounded-circle bg-light btn-shadow call-to-action"
                                >
                                    <HappyCertificate
                                        alt="leadership coaching"
                                        className="img img-fluid p-4"
                                    />
                                </Button>
                            </Col>
                        </Row>
                    <Row>
                        <Col>
                            <h5 className="my-2 text-center font-weight-bolder text-secondary text-uppercase">
                                {leadersButton2Title}                            
                            </h5>
                            <Button
                            variant="light"
                            onClick={() => handleModalClick(8, modalShow)}
                            className="rounded-circle bg-light btn-shadow call-to-action"
                            >
                                <Certified
                                    alt="certified leader"
                                    className="img img-fluid p-4"
                                />
                            </Button>

                        </Col>
                    </Row>
                </Col>
            </Row>

                <Row className="large-row my-5 align-items-center">
                    <Col sm="12" md="6" className="d-flex text-center">
                        <CallToAction callToActionText={teamsCallToActionHeader} callToActionKeyword={teamsCallToActionKeyword} type="text-success"/>
                    </Col>
                    <Col sm="12" md="6" className="d-flex align-content-center justify-content-center">
                        <Button variant="warning" href="#contact" className="inner-link btn-lg btn-shadow font-weight-bolder">
                            <h3 className="font-weight-bolder text-uppercase m-0">{teamsCallToActionButtonText}</h3>
                        </Button>
                    </Col>
                </Row>
            </Container>

            <MyModal modalShow={modalShow} modalKey={modalKey} onHide={handleModalClose} onNextClick={onNextClick} />

        </section>
    )
}

export default Leaders
